import React from 'react'
import { Link } from 'react-router-dom';
const Banner = (props) => {
    return (
        <>
            <section  className='py-4'>
                <div className="container ">
                    <div className="row">
                        <div className="col-lg-12">
                          
                                {/* <small className='text-warn'>Lorem Ipsum</small> */}
                                <h2 className='font-weight-light text-capitalize text-black-50'>{props.title}</h2>
                                {/* <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li className="slash">/</li>
                                    <li className="active">{props.title}</li>
                                </ul> */}
                    
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Banner